import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 我的关注
export function getattention(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/attention', 
    method: 'get',
    params
  })
}

// 商铺基本信息(前台)
export function getBasicShopMsg(params) {
  return axios.request({
    url: urlObj.crm + 'crm/tenant/shopinfo',
    method: 'get',
    params
  })
}

// 查销量
export function getsales(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/order/tenant/month/sales',
    method: 'get',
    params
  })
}

// 热销配件（商铺）
export function getSalesVolume(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/partsBatch/getSalesVolume',
    method: 'get',
    params
  })
}

// 加入购物车(前台)
export function getshopcar(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/shopping/saveShoppingCart',
    method: 'post',
    data
  })
}
// 购买
export function prebuy(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/orders/parts/prebuy',
    method: 'post',
    data
  })
}
